import React, { FC } from 'react';
import { CustomSelectProps } from './CustomSelectProps';
import FormField from '@ingka/form-field';
import Select, { Option } from '@ingka/select';
import { Controller, useFormContext } from 'react-hook-form';
import { returnDisabledStatus } from '../../utils/fieldEditingRules';
import InputField from '@ingka/input-field';
import { returnDisplay } from './utils';
import skapaColours from '@ingka/variables/colours-css';

const CustomSelect: FC<CustomSelectProps> = ({
  optionsArray,
  name,
  label,
  dataTestID,
  required,
  disabled = false,
  defaultValue = '',
  disableOnAll = true,
  customOnChange = () => {
    // do nothing
  },
  additionalStyle,
}) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const disabledFields = watch('disabledFields');
  return (
    <Controller
      render={({ field: { onChange, value } }) => (
        <FormField
          valid={!errors[name]}
          shouldValidate={!!errors[name]}
          className={'green-validation-disabled'}
          validation={{
            id: `validation-message-${name}`,
            msg: errors[name]?.message,
            type: 'error',
          }}
          style={{ marginBottom: 0, ...additionalStyle }}
        >
          {(
            required && !value
              ? false
              : disabled ||
                returnDisabledStatus(disabledFields, name, disableOnAll)
          ) ? (
            <InputField
              className={'read-only-input'}
              id={dataTestID}
              type={'text'}
              label={`${label}${required ? ' *' : ''}`}
              value={returnDisplay(value ?? defaultValue, optionsArray)}
              data-testid={dataTestID}
              readOnly
            />
          ) : (
            <Select
              style={{ color: skapaColours.colourNeutral7 }}
              id={`${name}-select`}
              label={`${label}${required ? ' *' : ''}`}
              data-testid={dataTestID}
              onChange={(e) => {
                const finalValue =
                  e.target.value === 'null' ? null : e.target.value;
                const finishedEvent = {
                  ...e,
                  target: { ...e.target, value: finalValue },
                };
                onChange(finishedEvent);
                customOnChange(finishedEvent);
              }}
              value={value ? value : defaultValue}
              disabled={
                required && !value
                  ? false
                  : disabled ||
                    returnDisabledStatus(disabledFields, name, disableOnAll)
              }
              selected-value={optionsArray?.[value]}
            >
              {Array.isArray(optionsArray) ? (
                <>
                  {optionsArray.map((opt, index) => (
                    <Option
                      key={opt + Math.random() * index}
                      value={opt}
                      name={opt}
                    />
                  ))}
                </>
              ) : (
                <>
                  {Object.keys(optionsArray || {}).map((opt, index) => (
                    <Option
                      key={opt + Math.random() * index}
                      value={opt}
                      name={optionsArray[opt]}
                    />
                  ))}
                </>
              )}
            </Select>
          )}
        </FormField>
      )}
      control={control}
      name={name}
    />
  );
};

export default CustomSelect;
